import * as XLSX from "xlsx-js-style";
import { getStrDateLong, postgresDateToIndonesia } from "./MyUtils";

const alphaToNum = (alpha) => {
  let num = 0;
  for (let i = 0; i < alpha.length; i += 1) {
    num = num * 26 + alpha.charCodeAt(i) - 0x40;
  }
  return num - 1;
};

const numToAlpha = (num) => {
  let alpha = "";
  for (; num >= 0; num = num / 26 - 1) {
    alpha = String.fromCharCode((num % 26) + 0x41) + alpha;
  }
  return alpha;
};

const buildColumnsArray = (sheet, name = "!ref") => {
  const rangeNum = sheet[name]
    .split(":")
    .map((val) => alphaToNum(val.replace(/[0-9]/g, "")));
  const result = [];
  for (let i = rangeNum[0]; i < rangeNum[1] + 1; i += 1) {
    result.push(numToAlpha(i));
  }
  return result;
};

export const autoFitColumns = (worksheet, sheetname = "!ref") => {
  const objectMaxLength = [];
  const lastRow = XLSX.utils.decode_range(worksheet[sheetname]).e.r;

  let idx = 0;
  for (const column of buildColumnsArray(worksheet, sheetname)) {
    let maxCellLength = 0;
    if (idx > 0) {
      for (let row = 1; row <= lastRow + 1; row += 1) {
        const cell = worksheet[`${column}${row}`];
        if (cell != null) {
          const cellLength = Math.ceil(String(cell.v).length * 1.25);
          if (cellLength > maxCellLength) maxCellLength = cellLength;
        }
      }
    } else {
      maxCellLength = 5;
    }
    idx += 1;
    objectMaxLength.push({ width: maxCellLength });
  }

  worksheet["!cols"] = objectMaxLength;
};

const sCellHeader = (haligment) => ({
  font: { name: "Arial", sz: 10, bold: true },
  fill: { fgColor: { rgb: "E9E9E9" } },
  alignment: { wrapText: true, horizontal: haligment, vertical: "top" },
  border: {
    top: { color: { rgb: "000000" }, style: "thin" },
    left: { color: { rgb: "000000" }, style: "thin" },
    right: { color: { rgb: "000000" }, style: "thin" },
    bottom: { color: { rgb: "000000" }, style: "thin" },
  },
});

const sCell = (haligment) => ({
  font: { name: "Arial", sz: 9, bold: false },
  alignment: { wrapText: true, horizontal: haligment, vertical: "top" },
  border: {
    top: { color: { rgb: "000000" }, style: "thin" },
    left: { color: { rgb: "000000" }, style: "thin" },
    right: { color: { rgb: "000000" }, style: "thin" },
    bottom: { color: { rgb: "000000" }, style: "thin" },
  },
});

const sCellFlat = (fsize = 9, haligment = "left") => ({
  font: { name: "Arial", sz: fsize, bold: true },
  alignment: { wrapText: false, horizontal: haligment, vertical: "top" },
});

export const cellH = (val, align = "left") => ({
  v: val,
  t: "s",
  s: sCellHeader(align),
});
export const cellV = (val, align = "left") => ({
  v: val,
  t: "s",
  s: sCell(align),
});
export const cellEmpty = { v: "" };
export const cellFlat = (val) => ({ v: val, t: "s", s: sCellFlat(10) });

export const cellFilter = (filtered, filter) => {
  const usedFilter = Array.isArray(filtered)
    ? filtered.map((field) => {
        const { dtype, name, label, options, valueId, labelId } = field;
        if (dtype && name) {
          switch (dtype) {
            case "dropdown": {
              const items =
                options &&
                options.filter(
                  (itemop) =>
                    String(itemop[valueId]) === String(filter?.[name]),
                );
              if (items && items.length > 0) {
                return [label + ": " + items[0][labelId]];
              }
              return null;
            }
            case "q": {
              const keyword = filter?.q;
              if (keyword && keyword.length > 0) {
                return ["Keywords: " + keyword];
              }
              return null;
            }
            case "date":
              if (filter?.[name]) {
                return [label + ": " + (postgresDateToIndonesia(filter?.[name]) || getStrDateLong(filter?.[name]))];
              }
              return null;
            default:
              return null;
          }
        }
        return null;
      })
    : [];

  const result = usedFilter.filter((item) => item != null);
  return result.length > 0 ? [...result, [cellEmpty]] : [[cellEmpty]];
};
